import {
  GROUP_NAME_MIN_LENGTH,
  GROUP_NAME_MAX_LENGTH,
  GROUP_DESCRIPTION_MAX_LENGTH,
  GROUP_MAX_MEMBERS
} from './constant';

/**
 * Interface pour les données du formulaire de groupe
 */
export interface GroupFormData {
  name: string;
  description: string;
  memberUuids: string[];
}

/**
 * Valide les données d'un formulaire de groupe (création ou édition)
 *
 * @param data - Les données du formulaire à valider
 * @returns Une chaîne vide si valide, un message d'erreur sinon
 *
 * @example
 * const error = validateGroupForm({
 *   name: "Équipe Marketing",
 *   description: "Groupe pour l'équipe marketing",
 *   memberUuids: ["uuid1", "uuid2"]
 * });
 * if (error) {
 *   setFormError(error);
 *   return;
 * }
 */
export const validateGroupForm = (data: GroupFormData): string => {
  const trimmedName = data.name.trim();
  const trimmedDesc = data.description.trim();

  // Validation nom du groupe
  if (!trimmedName) {
    return 'Le nom du groupe est requis';
  }

  if (trimmedName.length < GROUP_NAME_MIN_LENGTH) {
    return `Le nom du groupe doit contenir au moins ${GROUP_NAME_MIN_LENGTH} caractères`;
  }

  if (trimmedName.length > GROUP_NAME_MAX_LENGTH) {
    return `Le nom du groupe ne peut pas dépasser ${GROUP_NAME_MAX_LENGTH} caractères`;
  }

  // Validation description
  if (trimmedDesc.length > GROUP_DESCRIPTION_MAX_LENGTH) {
    return `La description ne peut pas dépasser ${GROUP_DESCRIPTION_MAX_LENGTH} caractères`;
  }

  // Validation membres
  if (data.memberUuids.length === 0) {
    return 'Vous devez sélectionner au moins un membre';
  }

  if (data.memberUuids.length > GROUP_MAX_MEMBERS) {
    return `Vous ne pouvez pas sélectionner plus de ${GROUP_MAX_MEMBERS} membres`;
  }

  // Aucune erreur
  return '';
};